import { render } from "./edituser.vue?vue&type=template&id=460ebbec"
import script from "./edituser.vue?vue&type=script&lang=js"
export * from "./edituser.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-AfyunProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__